export default __webpack_public_path__ + "5c8d9c215e58c2b6fe27bd0619a1ab92.png";